import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultSearchEvents = {
    onCurrentValuesChange: noop,
    onLatestValuesChange: noop
};

function useSearchEvents(props) {
    const {
        searchEvents: propsSearchEvents
    } = props;

    const {
        events: searchEvents
    } = useEvents(defaultSearchEvents, propsSearchEvents);

    const result = {
        searchEvents
    };

    useDebugValue(result);

    return result;
}

export {useSearchEvents};
